import React from 'react';
import styled, { css } from 'styled-components';
export type FlexCardProps = {
  direction?: string;
  justify?: string;
  alignItems?: string;
  height?: string;
  width?: string;
  space?: number;
  inline?: boolean;
};

const FlexCard = styled.div<FlexCardProps & React.HTMLProps<HTMLDivElement>>`
  overflow: auto;
  display: ${({ inline }) => (inline ? 'inline-flex' : 'flex')};
  flex-wrap: nowrap;
  align-items: ${({ alignItems }) => alignItems || 'center'};
  justify-content: ${({ justify }) => justify || 'flex-start'};
  background: ${({ theme }) => theme.color.white};
  min-height: ${({ height }) => height || '100vh'};
  max-height: ${({ height }) => height || '100vh'};
  width: ${({ width }) => width || '100%'};
  ${({ direction }) =>
    direction &&
    css`
      flex-direction: ${direction};
    `};

  & > * {
    margin: 0;

    &:not(:last-child) {
      ${({ theme, direction, space }) =>
        direction === 'column' &&
        css`
          margin-bottom: ${theme.spacing.base *
          (space !== undefined ? space : 1)}px;
        `}

      ${({ theme, direction, space }) =>
        (!direction || direction === 'row') &&
        css`
          margin-right: ${theme.spacing.base *
          (space !== undefined ? space : 1)}px;
        `}
    }
  }
`;

export default FlexCard;
